"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.efimovFactorDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var efimovFactorDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createEfimovFactor: _factoriesAny.createEfimovFactor
};
exports.efimovFactorDependencies = efimovFactorDependencies;